const {EventBusSingleton} = require('light-event-bus');

export function registerGlobalSubscribers() {
    EventBusSingleton.subscribe('newMessagesCountLabelChange', changeNewMessagesCountLabel);
}

const changeNewMessagesCountLabel = (newLabelValue) => {


    let newMessagesCountLabel = document.getElementById('newMessagesCountLabel');
    if (newMessagesCountLabel) {

        if (newLabelValue > 0) {
            newMessagesCountLabel.innerText = newLabelValue;
        } else {
            newMessagesCountLabel.innerText = 'ok';
        }

    } else {
        console.error('Element with id newMessagesCountLabel for unread counter not found on page');
    }
};

export class GlobalEvents {

    updateNewMessageCountLabel() {
        let apiUrl = '/api/current-user/unread-events-count';
        fetch(apiUrl)
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.debug(`Fetched unread events count (${apiUrl}).`, data);
                EventBusSingleton.publish('newMessagesCountLabelChange', data.result);
            })
            .catch(err => {
                console.error(`Can not fetch unread events count  (${apiUrl}).`, err);
            });
    }

}
